import React from 'react';

const DimensionSelector = ({ onSelectDimension, onStartFullTest }) => {
  // Definisi dimensi-dimensi yang tersedia
  const dimensions = [
    { 
      id: 'structureVsFlexibility',
      name: 'Terstruktur vs Fleksibel',
      description: 'Mengevaluasi preferensi Anda terhadap lingkungan terstruktur atau fleksibilitas dan adaptasi.',
      icon: '📝',
      color: 'blue'
    },
    { 
      id: 'introvertVsExtrovert',
      name: 'Introvert vs Ekstrovert',
      description: 'Mengukur kecenderungan Anda dalam interaksi sosial dan sumber energi Anda.',
      icon: '👥',
      color: 'purple'
    },
    { 
      id: 'practicalVsConceptual',
      name: 'Praktis vs Konseptual',
      description: 'Menilai preferensi Anda antara pendekatan praktis atau pemikiran konseptual.',
      icon: '💡',
      color: 'green'
    },
    { 
      id: 'riskVsCaution',
      name: 'Pengambil Risiko vs Kehati-hatian',
      description: 'Mengukur kecenderungan Anda dalam menghadapi risiko dan ketidakpastian.',
      icon: '🎯',
      color: 'orange'
    },
    { 
      id: 'independentVsCollaborative',
      name: 'Mandiri vs Kolaboratif',
      description: 'Mengevaluasi preferensi Anda bekerja secara mandiri atau dalam kelompok.',
      icon: '🤝',
      color: 'indigo'
    }
  ];

  // Function to get color classes based on dimension color
  const getColorClasses = (color) => {
    const colorMap = {
      blue: {
        light: 'bg-blue-50 border-blue-200 hover:bg-blue-100',
        icon: 'bg-blue-100 text-blue-600',
        text: 'text-blue-800'
      },
      purple: {
        light: 'bg-purple-50 border-purple-200 hover:bg-purple-100',
        icon: 'bg-purple-100 text-purple-600',
        text: 'text-purple-800'
      },
      green: {
        light: 'bg-green-50 border-green-200 hover:bg-green-100',
        icon: 'bg-green-100 text-green-600',
        text: 'text-green-800'
      },
      orange: {
        light: 'bg-orange-50 border-orange-200 hover:bg-orange-100',
        icon: 'bg-orange-100 text-orange-600',
        text: 'text-orange-800'
      },
      indigo: {
        light: 'bg-indigo-50 border-indigo-200 hover:bg-indigo-100',
        icon: 'bg-indigo-100 text-indigo-600',
        text: 'text-indigo-800'
      }
    };
    
    return colorMap[color] || colorMap.blue;
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-3">Tes Learning Agility BUMN</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Pilih seluruh tes untuk evaluasi lengkap, atau pilih dimensi spesifik untuk fokus pada aspek tertentu dari kepribadian Anda.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-8">
          <div className="bg-blue-600 px-6 py-4">
            <h2 className="text-xl font-semibold text-white">Pilihan Tes</h2>
          </div>
          
          <div className="p-6">
            <div 
              onClick={onStartFullTest}
              className="bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg p-6 mb-8 cursor-pointer hover:shadow-lg transform hover:-translate-y-1 transition-all duration-200 shadow-md"
            >
              <div className="flex items-center">
                <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm text-white flex items-center justify-center text-2xl mr-4 shadow-inner">
                  🧠
                </div>
                <div>
                  <h3 className="text-xl font-bold">Tes Lengkap</h3>
                  <p className="text-blue-100 mt-1">
                    Mengerjakan seluruh tes untuk evaluasi komprehensif (50 pertanyaan)
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-lg font-medium text-gray-800 mb-4 flex items-center">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-blue-500 mr-2"></span>
              Atau pilih dimensi spesifik:
            </h3>
            
            <div className="grid gap-4 md:grid-cols-2">
              {dimensions.map(dimension => {
                const colorClasses = getColorClasses(dimension.color);
                
                return (
                  <div 
                    key={dimension.id}
                    onClick={() => onSelectDimension(dimension.id)}
                    className={`border rounded-lg p-5 cursor-pointer shadow-sm transform hover:-translate-y-1 hover:shadow-md transition-all duration-200 ${colorClasses.light}`}
                  >
                    <div className="flex items-start">
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center text-xl mr-4 shadow-sm ${colorClasses.icon}`}>
                        {dimension.icon}
                      </div>
                      <div>
                        <h4 className={`font-bold text-lg ${colorClasses.text}`}>{dimension.name}</h4>
                        <p className="text-gray-600 mt-1">
                          {dimension.description}
                        </p>
                        <span className="inline-block mt-3 text-sm font-medium text-gray-500">
                          {dimension.id === 'structureVsFlexibility' ? '10 pertanyaan' : 
                           dimension.id === 'introvertVsExtrovert' ? '10 pertanyaan' : 
                           dimension.id === 'practicalVsConceptual' ? '6 pertanyaan' : 
                           dimension.id === 'riskVsCaution' ? '6 pertanyaan' : 
                           '9 pertanyaan'}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="text-center text-sm text-gray-500">
          <p>© 2025 BUMN Learning Agility Test</p>
        </div>
      </div>
    </div>
  );
};

export default DimensionSelector;